"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef } from "react";
export default function Hero() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.2
  });
  const parallaxRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (parallaxRef.current) {
        const scrolled = window.scrollY;
        parallaxRef.current.style.transform = `translateY(${scrolled * 0.1}px)`;
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section className="dark-section bg-dark-background text-foreground-dark relative min-h-screen flex items-center justify-center overflow-hidden" id="hero">
      <div ref={parallaxRef} className="absolute inset-0 w-full h-[120%] -top-[10%]">
        <div className="relative w-full h-full">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541635/img/hero_neural_network_abstract.png" alt="Abstract neural network visualization" className="w-full h-full object-cover opacity-40" />
          <div className="surface-overlay absolute inset-0 opacity-60" />
        </div>
      </div>

      <div className="relative z-10 container mx-auto px-4 py-16">
        <div ref={contentRef} className={`max-w-4xl mx-auto transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"}`}>
          <div className="glass-effect p-12 md:p-16 rounded-md">
            <h1 className="font-display font-bold leading-tight ![margin:0px_0px_24px_0px] !text-5xl md:!text-6xl text-foreground-dark text-left">AI Strategy &amp; Governance for Enterprise Leaders.</h1>

            <p className="text-foreground-dark/90 mb-6 max-w-2xl leading-relaxed !text-xl md:!text-2xl font-medium">We advise boards, executives, and leadership teams on designing, governing, and scaling AI initiatives with clarity, control, and disciplined execution.</p>
            <p className="text-foreground-dark/70 mb-10 max-w-2xl leading-relaxed text-lg">
              Artificial intelligence creates opportunity — but unmanaged, it introduces operational, regulatory, and strategic risk. StrategyAI Partners provides structured advisory and oversight so leadership remains firmly in control of outcomes, exposure, and long-term value creation.
            </p>

            <div className="flex flex-col sm:flex-row flex-wrap gap-6 items-center justify-start">
              <Link to="/contact">
                <Button size="lg" variant="outline" className="hover-lift bg-secondary border-secondary/20 text-white hover:bg-secondary-hover px-7 py-3 rounded-sm h-auto">
                  Request Executive Consultation
                </Button>
              </Link>

              <Link to="/ServicesPage">
                <Button size="lg" variant="outline" className="hover-lift bg-primary/10 border-white/20 text-white hover:bg-white/10 px-7 py-3 rounded-sm h-auto">
                  Explore Advisory Services
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-48 bg-gradient-to-t from-dark-background to-transparent pointer-events-none" />
    </section>;
}